import { toSnakeCase } from './string';

export const pluck =
	<K extends string>(key: K) =>
	<T extends Record<K, unknown>>(value: T) =>
		value[key];

export const hasPropWithValue =
	<P extends string, O>(prop: P, value: unknown) =>
	(object: O) =>
		object[prop as unknown as keyof O] === value;

/**
 * Recursively converts all object keys from camelCase to snake_case.
 * Arrays are preserved as-is.
 */
export const toSnakeCaseKeys = (obj: any): any => {
	if (Array.isArray(obj)) {
		return obj;
	}
	if (obj !== null && typeof obj === 'object') {
		return Object.fromEntries(Object.entries(obj).map(([key, value]) => [toSnakeCase(key), toSnakeCaseKeys(value)]));
	}
	return obj;
};
